import { isLocaleEnabled } from "@repo/shared";

/**
 * QL-17 — the language for screens that render before (or without) the user's
 * session: the error boundary and the app-shell load error. Last language this
 * browser used, then the browser's own language, then en_GB.
 */
export function detectBrowserLanguage(): string {
  if (typeof window === "undefined") return "en_GB";
  try {
    const stored = localStorage.getItem("userLanguage");
    if (stored && isLocaleEnabled(stored)) return stored;
  } catch {
    // Storage can be blocked (private mode, site data off) — fall through.
  }
  const browserLang = navigator.language;
  if (browserLang.startsWith("nb") || browserLang.startsWith("no")) return "nb_NO";
  return "en_GB";
}
